import React, { useState, useEffect } from 'react'
import { Panel, Row, Icon, Table, ButtonGroup, IconButton } from 'rsuite'

export default function AttachFilesMakeContractView({ schema, onPreview, onDownload, onDelete = () => {}, enableDelete, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  return (
    // <Panel header="" eventKey={2} shaded style={{ marginBottom: '2em' }}>
    <Row style={{ marginBottom: '2em' }}>
      <Table
        autoHeight={schema?.value?.length > 4 ? false : true}
        height={400}
        wordWrap
        bordered
        data={schema?.value ? [...schema.value] : []}
      >
        <Column width={90} align="center" fixed>
          <HeaderCell>ไฟล์ที่</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>
        <Column minWidth={500} width={500} flexGrow={1}>
          <HeaderCell>ชื่อไฟล์</HeaderCell>
          <Cell dataKey="label" />
        </Column>

        {props.showContractFileType && (
          <Column minWidth={200} width={200} flexGrow={1}>
            <HeaderCell>ประเภทไฟล์</HeaderCell>
            <Cell dataKey="contractFileType" />
          </Column>
        )}

        <Column width={150} align="center" fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData, index) => {
              return (
                <ButtonGroup>
                  <IconButton
                    appearance="ghost"
                    icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                    onClick={(e) => onPreview(rowData)}
                  />
                  <IconButton
                    appearance="ghost"
                    icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                    onClick={(e) => onDownload(rowData)}
                  />
                  {enableDelete && (
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="trash" className="bt-gost-icon-radius-last-cancel" />}
                      onClick={(e) => onDelete(rowData)}
                    />
                  )}
                </ButtonGroup>
              )
            }}
          </Cell>
        </Column>
      </Table>
    </Row>
    // </Panel>
  )
}
